/**
 * @generated SignedSource<<90be9461cc911ddecae2396b062c5242>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceExampleProject_portfolioProject$data = {
  readonly cover: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
  };
  readonly slug: string;
  readonly title: string;
  readonly " $fragmentType": "ProductizedServiceExampleProject_portfolioProject";
};
export type ProductizedServiceExampleProject_portfolioProject$key = {
  readonly " $data"?: ProductizedServiceExampleProject_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceExampleProject_portfolioProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceExampleProject_portfolioProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectCoverWrapper_portfolioProjectCover"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};

(node as any).hash = "19727e605c18e1479fe9a082aadefb70";

export default node;
